export interface NextRound {
  id: number;
  number: number;
  name: string;
  startDate: string | null;
  status: string;
}

export interface LeagueCardData {
  id: number;
  name: string;
  discipline: string;
  status: string;
  signupMode?: 'PRIVATE' | 'OPEN' | 'APPROVAL' | 'APPROVAL_EXCEPT_MEMBERS' | null;
  venue?: string | null;
  venueCity?: string | null;
  club?: { slug: string; name: string; publicListed?: boolean } | null;
  nextRound?: NextRound | null;
  lastRound?: { id: number; number: number; name: string; startDate: string } | null;
  openRound?: NextRound | null;
}

const DISCIPLINE_LABELS: Record<string, string> = {
  SINGLES: 'Singiel',
  SINGLES_M: 'Singiel M',
  SINGLES_F: 'Singiel K',
  SINGLES_MIX: 'Singiel Mix',
  DOUBLES: 'Debel',
  DOUBLES_M: 'Debel M',
  DOUBLES_F: 'Debel K',
  DOUBLES_MIX: 'Debel Mix',
  MIXED: 'Mikst',
  CUSTOM: 'Inna',
};

export function disciplineLabel(discipline: string): string {
  return DISCIPLINE_LABELS[discipline] ?? discipline;
}

export function disciplineVariant(discipline: string): 'singles' | 'doubles' | 'mixed' {
  if (['DOUBLES', 'DOUBLES_M', 'DOUBLES_F'].includes(discipline)) {
    return 'doubles';
  }
  if (['MIXED', 'SINGLES_MIX', 'DOUBLES_MIX'].includes(discipline)) {
    return 'mixed';
  }

  return 'singles';
}

export function venueLine(league: LeagueCardData): string | null {
  const parts = [league.venue?.trim(), league.venueCity?.trim()].filter(
    (s): s is string => Boolean(s && s.length > 0)
  );
  if (parts.length === 0) {
    return null;
  }

  return parts.join(' · ');
}
